import { MetabaseCard } from '@shared/components/metabase';
import { ReportCard } from '@shared/components/report-manager';
export class FinanceReportCard extends ReportCard {}
export class FinanceReportsModel extends MetabaseCard {}
